import { AxiosResponse } from 'axios';
import { IMarketplace } from 'shared/types/marketplace';
import { IMarketplacePayment } from 'shared/types/marketplacePayment';
import {
  AccreditationPayload,
  AccreditationResponse,
} from './interfaces/accreditation';
import { WeekendPayoutStatusPayload } from './interfaces/weekendPayout';
import { apiV2 } from './http';

export function listMarketplaceByIdi(
  idi: string,
): Promise<AxiosResponse<IMarketplace>> {
  return apiV2.get<IMarketplace>(`marketplace/list/${idi}`);
}

export function createMarketplaceAccreditation(
  payload: AccreditationPayload,
): Promise<AxiosResponse<AccreditationResponse>> {
  return apiV2.post<AccreditationResponse>(
    `marketplace/accreditation`,
    payload,
  );
}

export function updateMarketplacePayment(
  payload: IMarketplacePayment,
): Promise<AxiosResponse> {
  return apiV2.post(`marketplace/update/fees`, payload);
}

export function disableMarketplacePayment(
  idi: string,
  customerId: number,
): Promise<AxiosResponse> {
  return apiV2.post(`marketplace/disable/${idi}`, { customerId });
}

export function getWeekendPayoutStatus(
  idi: string,
): Promise<AxiosResponse<WeekendPayoutStatusPayload>> {
  return apiV2.get<WeekendPayoutStatusPayload>(
    `marketplace/weekend-payout/${idi}`,
  );
}

export function blockWeekendPayout(
  idi: string,
  customerId: number,
): Promise<AxiosResponse> {
  return apiV2.post(`marketplace/weekend-payout/${idi}`, { customerId });
}

export function unblockWeekendPayout(
  idi: string,
  customerId: number,
): Promise<AxiosResponse> {
  return apiV2.delete(`marketplace/weekend-payout/${idi}`, {
    data: { customerId },
  });
}
